 
window.App = window.App || {};
window.App = window.App || {};
window.App.progress = { value: window.scrollY || 0 }; 
App.modules = App.modules || {};
import gsap from "gsap" 
//import { WipeStaggerCover } from '../library_v/presets/scrolladdons/wipe_stagger_cover_lazy_io_v5.mod.js';App.modules.wipe_reveal = WipeStaggerCover(); 
import { ScrollMomentumBoilerplate } from '../library_v/presets/scrolladdons/scroll_momentum_boilerplate.mod.js';App.modules.wipe_reveal = ScrollMomentumBoilerplate(); 
import { CanvasDispersion } from '../library_v/presets/scrolladdons/scroll_momentum/canvas_dispersion2.mod.js';App.modules.canvas_dispersion = CanvasDispersion(); 
import { LazyLoadQueue } from '../library_v/utils/lazyload_queue2.mod.js';App.modules.lazy_queue = LazyLoadQueue();
import { ElasticStagger } from '../library_v/presets/scrolladdons/scroll_momentum/elastic_stagger2.mod.js';App.modules.cube_wave = ElasticStagger();App.modules.circle_wave = ElasticStagger();
import { GalleryPinnedFilmstrip } from '../library_v/presets/scrolladdons/galleries/gallery_pinned_filmstrip.mod.js';App.modules.filmstrip = GalleryPinnedFilmstrip();


function initApp() {
// Detect if the user's OS requests reduced motion
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// =========================================================================
// GLOBAL IO REGISTRY
// =========================================================================

const activeSections = new Set();
const activeStaggerElements = new Set();

const globalObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const target = entry.target;
    
    // 1. Handle standard string-based sections (like the Gallery)
    const sectionName = target.getAttribute('data-unique');
    if (sectionName) {
      if (entry.isIntersecting) {
        activeSections.add(sectionName);
      } else {
        activeSections.delete(sectionName);
      }
    }

    // 2. Handle DOM node-based sections (like reusable Stagger text)
    if (target.hasAttribute('data-common')) {
      if (entry.isIntersecting) {
        activeStaggerElements.add(target);
      } else {
        activeStaggerElements.delete(target);
      }
    }

    // 3. Handle V2 Addons (like WipeStaggerCover) seamlessly
    // If the module attached its setter to the HTML node, the Global IO fires it automatically
    if (typeof target._setVisibility === 'function') {
      target._setVisibility(entry.isIntersecting);
    }
  });
}, { rootMargin: "100px 0px" });

// Auto-Initialize Everything on the page
//document.querySelectorAll('[data-unique], [data-common], .lazy-reveal-wrapper').forEach(el => {
document.querySelectorAll('[data-unique], [data-common]').forEach(el => {
  globalObserver.observe(el);
});



// =========================================================================
// INITIALIZE EXTERNAL ADDONS
// =========================================================================
if(App.modules.filmstrip && !prefersReducedMotion){App.modules.filmstrip.init();}

if(App.modules.wipe_reveal){
if (!prefersReducedMotion) {
  App.modules.wipe_reveal.init({
      targets: ".lazy-reveal-wrapper",
      wipeSensitivity: 4000, 
      intensity: 0.05
  });
}
}
 
if(App.modules.canvas_dispersion){
if (!prefersReducedMotion) {
  App.modules.canvas_dispersion.init({
      targets: ".dispersion-container",
	  imgclass: ".dispersion-img",
      intensity: 0.02,
      dispersionMaxRange: 700 
  });
}
}
 
if(App.modules.lazy_queue){
App.modules.lazy_queue.init({
      rootMargin: window.innerWidth < 768 ? "100% 0px" : "1500px 0px"
  });
}
 
if(App.modules.cube_wave){
App.modules.cube_wave.init({
    targets: ".testcube1, .testcube2, .testcube3, .testcube4",
    speeds: [0.05, 0.07, 0.1, 0.15],
    lerp: 0.05
});
}

if(App.modules.circle_wave){
App.modules.circle_wave.init({
    targets: ".testcircle1, .testcircle2, .testcircle3, .testcircle4, .testcircle5",
    speeds: [0.01, 0.02, 0.03, 0.04, 0.05],
    lerp: 0.02, // Much "laggier" wave
    intensity: 20, // More dramatic drift
//    props: ['y','opacity'], // Only position active
    props: ['y'], // Only position active
	opacitySensitivity: 300,
});
}
// =========================================================================
// GALLERY
// =========================================================================

////// HOVER DISABLE, prevents the browser from doing  layout repaints every time the mouse flies over a link or hover effect
const main = document.querySelector('.main'); // main scrollable content (keep fixed navigation elements out of this optimization type)
let isPointerActive = true;

// =========================================================================
// ANIMATION ENGINE
// =========================================================================

// Lenis Integration
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smooth: true,
  gestureDirection: "vertical",
  smoothTouch: false, // off to restore native iOS momentum
  touchMultiplier: 2
});
 // GSAP Unified Ticker Sync
function raf(time) {
  lenis.raf(time * 1000);

    // ANY: Only when lenis is initialized
    if (lenis.actualScroll !== undefined) {
    // Disable hover repaints during active momentum
const isScrollingNow = Math.abs(lenis.velocity) > 0.3;
if (isScrollingNow && isPointerActive) {
    main.style.pointerEvents = 'none';
    isPointerActive = false;
} else if (!isScrollingNow && !isPointerActive) {
    main.style.pointerEvents = '';
    isPointerActive = true;
}
	
    if (App.modules.wipe_reveal && !prefersReducedMotion) App.modules.wipe_reveal.update(lenis.actualScroll);
    if (App.modules.canvas_dispersion && !prefersReducedMotion) App.modules.canvas_dispersion.update(lenis.actualScroll);
	if (App.modules.cube_wave && !prefersReducedMotion) App.modules.cube_wave.update(lenis.actualScroll);
    if (App.modules.circle_wave && !prefersReducedMotion) App.modules.circle_wave.update(lenis.actualScroll);

    if (App.modules.filmstrip && !prefersReducedMotion) App.modules.filmstrip.update(lenis.actualScroll);
		
  }
  
}

gsap.ticker.add(raf);// Hook  into GSAP's internal render loop
}

initApp();

  